import { getData } from "../api/api";
import { parseDashboardIpFlowResponse } from "../lib/network/dashboardIpFlow";
import { EMPTY_IP_FLOW_MATRIX, type IpFlowMatrix } from "../lib/network/ipFlowMatrix";

class DashboardIpFlowService {
  async getIpFlows(customerId: string): Promise<IpFlowMatrix> {
    if (!customerId) {
      return {
        ...EMPTY_IP_FLOW_MATRIX,
        stats: { ...EMPTY_IP_FLOW_MATRIX.stats! },
      };
    }

    const response = await getData(
      `/dashboard/ip-flows?customerId=${encodeURIComponent(customerId)}`,
      { skipGlobalLoading: true },
    );
    return parseDashboardIpFlowResponse(response);
  }
}

export const dashboardIpFlowService = new DashboardIpFlowService();
